var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/message-send-officer.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-66be2564!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/message-send-officer.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MessageSendOfficer.vue
// module id = 1323
// module chunks = 1